"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputSize = void 0;
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const Input_types_1 = require("./Input.types");
const useInputSize = ({ size }) => {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    if (size === Input_types_1.InputSize.Large) {
        return theme.sizes['2xl'].value.replace('px', '');
    }
    return theme.sizes.xl.value.replace('px', '');
};
exports.useInputSize = useInputSize;
//# sourceMappingURL=Input.helper.js.map